import { useEffect, useRef } from 'react';
import { DynamicContentListData, TranslationData } from '../../model.ts';
import SeriesItemCard from '../../../../../../components/blackrock/advisor-center/cards/series-item-card/SeriesItemCard.tsx';
import { getImageFallbackListByItemType } from '../../../../../../components/blackrock/advisor-center/cards/series-item-card/_helpers/series-item-helpers.ts';
import {
	SaveBtnPosition,
	SeriesItemComponentData,
	SeriesItemData,
} from '../../../../../../components/blackrock/advisor-center/cards/series-item-card/SeriesItemCardProps.ts';
import { ITEM_PER_PAGE } from '../../dynamic-content.config.ts';
import { SavableSeriesItemData } from '../../../saved-page/SavedItemsReducer.ts';

export type ListProps = {
	list: SeriesItemData[];
	data: DynamicContentListData;
	translation: TranslationData;
	onChangeSavedState: (item: SavableSeriesItemData) => void;
	limit?: number;
	currentPage?: number;
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const List: React.FC<ListProps> = ({
	list,
	data,
	translation,
	onChangeSavedState,
	currentPage = 1,
	limit = ITEM_PER_PAGE,
}) => {
	const componentData: SeriesItemComponentData = {
		ariaLabelPrefix: data.translationMap?.readMore,
		saveConfig: data.saveConfig,
		writtenByLabel: translation.writtenBy,
	};

	const items = list.slice(0, limit * currentPage);
	const itemsRef = useRef<HTMLAnchorElement[]>([]);

	// a11y: set focus on the first new item on LoadMore
	useEffect(() => {
		if (currentPage === 1) return;

		const firstNewItemIndex = (currentPage - 1) * ITEM_PER_PAGE;
		itemsRef.current[firstNewItemIndex]?.focus();
	}, [currentPage]);

	return (
		!!items.length && (
			<ul className="list">
				{items.map((item, index) => (
					<li key={item.url}>
						<SeriesItemCard
							itemData={item}
							componentData={componentData}
							cardConfig={{
								displayImage: true,
								imageFallbackList: getImageFallbackListByItemType(
									item.itemType,
									data
								),
								saveBtnPosition:
									SaveBtnPosition.IN_THE_LOWER_RIGHT_CORNER_OF_THE_CARD,
								// eslint-disable-next-line @typescript-eslint/ban-ts-comment
								// @ts-ignore
								itemTypeIcon: data.iconMap[item.itemType],
							}}
							onSaveButtonClick={
								item.saveUrl && item.savable
									? () => onChangeSavedState(item as SavableSeriesItemData)
									: undefined
							}
							// eslint-disable-next-line @typescript-eslint/ban-ts-comment
							// @ts-ignore
							ref={(el) => (itemsRef.current[index] = el)}
						/>
					</li>
				))}
			</ul>
		)
	);
};

export default List;
